/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_Site_NameInputs */

const vi_shop_contact_site_name = /** @type {(inputs: Shop_Contact_Site_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên cửa hàng`)
};

/**

* @param {Shop_Contact_Site_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_site_name = /** @type {((inputs?: Shop_Contact_Site_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_Site_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_site_name(inputs)
});